import React from "react";
import { FaWhatsapp as FaWhatsappIcon } from "react-icons/fa";

import { ReactComponent as DeviceIcon } from "../../../assets/images/habitacional/device-icon.svg";

import {
  callLink,
  chatLink,
  chatLinks,
  clientAccess,
} from "./ChooseProductSection.constants";

export const HousingList = [
  {
    id: 1,
    title: "Sinistro (cobertura)",
    description: (
      <>
        <strong>Solicite ou acompanhe</strong> o pedido de indenização nas
        situações cobertas pelo seu seguro.
      </>
    ),
    links: [
      {
        id: "1-link",
        icon: DeviceIcon,
        title: "Ir para o site",
        description:
          "Com alguns cliques e a qualquer momento. Simples, fácil e confiável.",
        href: "/paravoce/habitacional#acionamento-sinistro",
        target: "_blank",
      },
      {
        id: "2-link",
        icon: FaWhatsappIcon,
        title: "Abrir WhatsApp",
        description: (
          <>
            No número <strong>0800 749 2020</strong>. De segunda a sexta, das 8h
            às 18h, exceto feriados nacionais.
          </>
        ),
        href: "https://wa.me/5508007492020",
      },
      {
        ...chatLink(chatLinks.habitacional.sinistro),
        id: "3-link",
        description:
          "Converse com um de nossos especialistas. De segunda a sexta, das 8h às 18h, exceto feriados nacionais.",
      },
      {
        ...callLink,
        id: "4-link",
      },
    ],
  },
  {
    id: 2,
    title: "Serviços e informações",
    description: (
      <>
        2ª via de documentos, detalhes sobre a validade do seguro, informações
        sobre coberturas e assistências contratadas, etc.
      </>
    ),
    links: [
      {
        ...chatLink(chatLinks.habitacional.servico),
        id: "1-link",
        description:
          "Converse com um de nossos especialistas. De segunda a sexta, das 8h às 21h. Sábados, domingos e feriados, das 9h às 17h.",
      },
      {
        ...clientAccess,
        id: "2-link",
      },
      {
        ...callLink,
        description:
          "De segunda a sexta, das 8h às 21h, exceto feriados nacionais.",
        id: "3-link",
      },
    ],
  },
  {
    id: 3,
    title: "Assistências",
    description: (
      <>
        <strong>Solicite ou acompanhe</strong> serviços de chaveiro, encanador,
        eletricista, entre outros. Apenas para os seguros Mais e Mais Premiável.{" "}
      </>
    ),
    links: [
      {
        ...chatLink(chatLinks.habitacional.assistencia),
        id: "1-link",
        description:
          "Converse com um de nossos especialistas. Atendimento 24 horas, todos os dias da semana, incluindo feriados nacionais.",
      },
      {
        ...callLink,
        description:
          "24 horas por dia, todos os dias da semana, incluindo feriados nacionais.",
        id: "3-link",
      },
    ],
  },
];
